import React from "react";
import { motion, useReducedMotion } from "framer-motion";

/**
 * Scroll-triggered content reveal. Deliberately small: a short rise and a
 * fade, nothing flying in from off-screen.
 */
export default function Reveal({
  children,
  delay = 0,
  y = 18,
  duration = 0.7,
  amount = 0.35,
  className,
  style,
  as = "div",
}) {
  const reduceMotion = useReducedMotion();
  const Tag = motion[as] || motion.div;

  if (reduceMotion) {
    const Plain = as;
    return (
      <Plain className={className} style={style}>
        {children}
      </Plain>
    );
  }

  return (
    <Tag
      className={className}
      style={style}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount }}
      transition={{
        duration,
        delay,
        ease: [0.22, 1, 0.36, 1],
      }}
    >
      {children}
    </Tag>
  );
}
